<template>
  <multiselect
    v-model="model"
    :options="prePopulate ? companies : options"
    :multiple="multiple"
    :custom-label="customToLabel"
    :disabled="disabled"
    deselectLabel="Klik om te deselecteren"
    selectLabel="Klik om te selecteren"
    selectedLabel="Geselecteerd"
    trackBy="id"
    label="name"
  >
    <template slot="noResult">
      Geen bedrijven gevonden, controleer uw zoekterm.
    </template>
    <template slot="tag" slot-scope="props">
      <span class="multiselect__tag">
        <span>{{ props.option.name }}</span>
        <i
          aria-hidden="true"
          tabindex="1"
          @keypress.enter.prevent="props.remove(props.option)"
          @mousedown.prevent="props.remove(props.option)"
          class="multiselect__tag-icon"
        ></i>
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { getData } from '../api';

export default {
  props: {
    multiple: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    prePopulate: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: null,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { Multiselect },
  data() {
    return {
      companies: [],
    };
  },
  computed: {
    model: {
      get() {
        let options = this.prePopulate ? this.companies : this.options;
        return typeof this.value === 'object'
          ? this.value
          : options.find((o) => o.id === this.value);
      },
      set(v) {
        let val;
        if (v === null) {
          val = null;
        } else {
          val = v.hasOwnProperty('value') ? v.value : v.id;
        }

        this.$emit('input', val);
      },
    },
  },
  methods: {
    customToLabel(item) {
      if (item.hasOwnProperty('id') && item.hasOwnProperty('name')) {
        return item.name;
      }
    },
    getData() {
      getData(`companies?per_page=9999`).then(({ data }) => {
        this.companies = data.data.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      });
    },
  },
  mounted() {
    if (this.prePopulate) {
      this.getData();
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
